let RecordingUtil = {};

/*
  Consolidate overlapping recordings such that they can be represented as
  "sessions" for visualization purposes.

  Returns [[t1, t2], [t3, t4], ...].
*/
RecordingUtil.sessions = function (recordings) {
  let sessions = [];

  recordings.map(function (r) {
    return [r.recordingStartTs, r.recordingStopTs];
  }).sort(function (a, b) {
    // is this necessary, or does the API guarantee order by date?
    return a[0] - b[0];
  }).forEach(function (r) {
    let i = sessions.length - 1;
    let s = sessions[i];

    if (i < 0 || r[0] > s[1]) {
      sessions.push(r);
    }
    else {
      s[1] = Math.max(s[1], r[1]);
    }
  });

  return sessions;
};

/*
  Get wear time per day in milliseconds, given sessions and subject time zone,
  for visualization purposes.

  Returns [{ dayStartMsUtc, recStartTs, wearTimeMillis }, ...]
*/
RecordingUtil.calendar = function (sessions, tz) {
  let map = {};

  let segments = mc.utils.flatten(sessions.map(function (session) {
    let [a, b] = session;

    let t1 = mc.tz.info(a, tz);
    let t2 = mc.tz.info(b, tz);
    let d2 = mc.tz.info(a, tz, "DAY_END");
    let res = [];

    while (t1.value < t2.value) {
      res.push({
        dayStartMsUtc: mc.tz.info(t1.value + t1.offset, "UTC", "DAY_START").value,
        recStartTs: t1.value,
        wearTimeMillis: Math.min(t2.value, d2.value) - t1.value
      });

      t1 = d2;
      d2 = mc.tz.info(t1.value, tz, "DAY_END");
    }

    return mc.utils.flatten(res);
  }));

  segments.forEach(function (segment) {
    let ts = segment.dayStartMsUtc;

    if (map[ts]) {
      map[ts].wearTimeMillis += segment.wearTimeMillis;
    }
    else {
      map[ts] = segment;
    }
  });

  return Object.values(map).sort(function (a, b) {
    return a.dayStartMsUtc - b.dayStartMsUtc;
  });
};

module.exports = RecordingUtil;
